(() => {
  const COMPANY_ID = 'YjAXYg';
  const ENDPOINT = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${COMPANY_ID}`;
  const SUBSCRIBE_ENDPOINT = `https://a.klaviyo.com/client/subscriptions/?company_id=${COMPANY_ID}`;
  const REVISION = '2024-10-15';
  const VARIANT_PREFIX = '$shopify:::$default:::';
  const MARKETING_LIST_ID = 'RAtS27';
  const SIGNUP_SOURCE = 'Back In Stock';
  const RETRY_DELAY_MS = 1200;

  const subscribe = async (email, variantId) => {
    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: VARIANT_PREFIX + variantId } }
          }
        }
      })
    });

    if (!res.ok) {
      let detail = res.status;
      try {
        const body = await res.json();
        detail = body?.errors?.[0]?.detail || detail;
      } catch (e) {}
      throw new Error(detail);
    }
  };

  const subscribeWithRetry = async (email, variantId) => {
    try {
      await subscribe(email, variantId);
    } catch (error) {
      await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS));
      await subscribe(email, variantId);
    }
  };

  const optInToMarketing = async (email) => {
    try {
      const res = await fetch(SUBSCRIBE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Back In Stock Form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    properties: { 'FT Signup Source': SIGNUP_SOURCE }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: MARKETING_LIST_ID } }
            }
          }
        })
      });
      return res.ok;
    } catch (e) {
      return false;
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ft-notify-me]');
    if (trigger) {
      const dialog = trigger
        .closest('.ft-product-summary__purchase-actions')
        ?.querySelector('[data-ft-notify-me-dialog]');
      if (!dialog) return;
      dialog.showModal();
      window.requestAnimationFrame(() => {
        dialog.querySelector('input[type="email"]')?.focus();
      });
      return;
    }

    const close = event.target.closest('[data-ft-notify-me-close]');
    close?.closest('[data-ft-notify-me-dialog]')?.close();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ft-notify-me-form]');
    if (!form) return;
    event.preventDefault();

    const dialog = form.closest('[data-ft-notify-me-dialog]');
    const actions = dialog?.closest('.ft-product-summary__purchase-actions');
    const trigger = actions?.querySelector('[data-ft-notify-me]');
    const status = actions?.querySelector('[data-ft-notify-me-status]');
    const input = form.querySelector('input[type="email"]');
    const optin = form.querySelector('[data-ft-notify-me-optin]');
    const submit = form.querySelector('[data-ft-notify-me-submit]');
    const message = form.querySelector('[data-ft-notify-me-message]');
    if (!dialog || !actions || !trigger || !input || !submit || !message) return;

    if (!input.checkValidity()) {
      input.reportValidity();
      return;
    }

    const email = input.value.trim().toLowerCase();
    const variantId = trigger.dataset.variantId;
    const wantsMarketing = Boolean(optin && optin.checked);
    if (!email || !variantId) return;

    submit.disabled = true;
    message.hidden = true;

    try {
      await subscribeWithRetry(email, variantId);

      if (wantsMarketing) {
        await optInToMarketing(email);
      }

      message.textContent = "We heard you. We'll email you when it's back in stock.";
      message.hidden = false;
      form.classList.add('ft-notify-me-dialog__form--success');
      actions.classList.add('ft-product-summary__purchase-actions--notify-success');
      trigger.hidden = true;
      if (status) status.hidden = false;

      submit.disabled = false;
      submit.type = 'button';
      submit.setAttribute('data-ft-notify-me-close', '');
      submit.querySelector('span')?.replaceChildren('Okay');

      document.dispatchEvent(
        new CustomEvent('ft:notify-me:subscribed', {
          detail: { variantId, productId: trigger.dataset.productId, marketingOptIn: wantsMarketing }
        })
      );
    } catch (error) {
      message.textContent = 'We could not register your notification request. Please try again.';
      message.hidden = false;
      submit.disabled = false;
    }
  });
})();